import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigSeguranca } from '../../../models/configseguranca.model';
import { AbConfigSeguranca } from 'app/abstract/full-pages/config-scond-key/config-seguranca.abstract';


@Injectable({ providedIn: 'root' })
export class ConfigSegurancaService extends AbConfigSeguranca {

  constructor(http: HttpClient) {
    super(http);
  }

  public getConfigSeguranca(): Observable<any> {
    return this.get(`configseguranca/1`);
  }

  public saveConfigSeguranca(configSeguranca: ConfigSeguranca): Observable<any> {
    return this.save(`configseguranca/`, configSeguranca);
  }
}